<template>
  <div id="app">
    <notifications group="e-notifications-alert" :duration="5000" animation-name="v-fade-left" position="top left" :width="400">
          <template slot="body" slot-scope="props">
            <div class="media bg-primary text-white p-3 mb-2" @click="props.close">
              <div class="media align-items-center w-100">
                <div class="mr-3">
                  <i class="lnr lnr-alarm" style="font-size: 250%;"></i>
                </div>
                <div class="media-body">
                  <strong class="e-mtavr-17">{{ props.item.title }}</strong><br>
                  <span class="e-nusx-8">{{ props.item.text }}</span>
                </div>
              </div>
            </div>
          </template>
        </notifications>
    <router-view />
  </div>
</template>

<style src="@/vendor/styles/bootstrap.scss" lang="scss"></style>
<style src="@/vendor/styles/appwork.scss" lang="scss"></style>
<style src="@/vendor/styles/theme-cotton.scss" lang="scss"></style>
<style src="@/vendor/styles/colors.scss" lang="scss"></style>
<style src="@/vendor/styles/uikit.scss" lang="scss"></style>
<style src="@/vendor/libs/vue-notification/vue-notification.scss" lang="scss"></style>
<style src="./style.scss" lang="scss"></style>

<script>
export default {
  name: 'app',
  metaInfo: {
    title: '',
    titleTemplate: 'ScreeningHub %s'
  },
  computed: {
    alert () {
      return this.$store.state.alert
    }
  },
  watch: {
    $route (to, from) {
      // clear alert on location change
      // this.$store.dispatch('alert/clear')
    }
  },
  updated () {
    // Remove loading state
    setTimeout(() => document.body.classList.remove('app-loading'), 1)
  }
}
</script>
